import React from "react";

const prettify = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return value;
};

const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
};

const resolveMediaUrl = (value, apiUrl) => {
  if (!value) return null;

  if (value.startsWith("data:")) return value;
  if (value.startsWith("http://") || value.startsWith("https://")) return value;

  // Raw base64 image content from eKYC response.
  if (value.startsWith("/9j/")) {
    return `data:image/jpeg;base64,${value}`;
  }
  if (value.startsWith("iVBOR")) {
    return `data:image/png;base64,${value}`;
  }

  if (value.startsWith("/")) {
    return `${apiUrl}${value}`;
  }

  return value;
};

const DetailRow = ({ label, value }) => (
  <tr>
    <th style={{ width: "32%", backgroundColor: "#f7f7f7" }}>{label}</th>
    <td>{prettify(value)}</td>
  </tr>
);

export default function AdharView({ agentData, isOpen, closePopup }) {
  if (!isOpen) return null;

  const API_URL = process.env.REACT_APP_BASE_URL_API || "";
  const aadharDetails = agentData?.aadharDetails || null;

  const frontImageUrl = resolveMediaUrl(agentData?.aadhar_front_image, API_URL);
  const backImageUrl = resolveMediaUrl(agentData?.aadhar_back_image, API_URL);
  const profileImageUrl = resolveMediaUrl(aadharDetails?.profile_image, API_URL);
  const aadhaarPdfUrl = resolveMediaUrl(aadharDetails?.aadhaar_pdf, API_URL);

  return (
    <div
      className="modal fade show"
      tabIndex={-1}
      aria-labelledby="documentModalLabel"
      aria-modal="true"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="documentModalLabel">
              Aadhaar Details View
            </h5>
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={closePopup}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body">
            {!aadharDetails ? (
              <div className="alert alert-warning mb-0" role="alert" style={{ textAlign: "center" }}>
                Aadhaar details not available for this agent.
              </div>
            ) : (
              <div className="container-fluid p-0">
                <div className="row">
                  <div className="col-md-5 mb-3">
                    <div className="panel panel-default mb-3">
                      <div className="panel-heading" style={{ padding: "10px 15px", fontWeight: 600 }}>
                        Document Images
                      </div>
                      <div className="panel-body" style={{ padding: 15 }}>
                        <div className="row">
                         
                         

                          <div className="col-12">
                            <h6 style={{ marginBottom: 8 }}>Profile Image</h6>
                            {profileImageUrl ? (
                              <img
                                src={profileImageUrl}
                                alt="Profile"
                                style={{ width: "100%", borderRadius: 8, border: "1px solid #ddd" }}
                              />
                            ) : (
                              <div className="text-muted">Not Available</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-7 mb-3">
                    <div className="panel panel-default mb-3">
                      <div className="panel-heading" style={{ padding: "10px 15px", fontWeight: 600 }}>
                        Verification Details
                      </div>
                      <div className="panel-body" style={{ padding: 0 }}>
                        <table className="table table-bordered table-striped mb-0">
                          <tbody>
                            <DetailRow label="Full Name" value={aadharDetails?.full_name} />
                            <DetailRow label="Aadhaar Number" value={aadharDetails?.aadhaar_number} />
                            <DetailRow label="Date of Birth" value={aadharDetails?.dob} />
                            <DetailRow label="Gender" value={aadharDetails?.gender} />
                            <DetailRow label="Status" value={aadharDetails?.status} />
                            <DetailRow label="Face Verified" value={aadharDetails?.face_status} />
                            <DetailRow label="Mobile Verified" value={aadharDetails?.mobile_verified} />
                            <DetailRow label="ZIP" value={aadharDetails?.zip} />
                           
                            <DetailRow label="Verified At" value={formatDateTime(aadharDetails?.verified_at)} />
                            <DetailRow label="Created At" value={formatDateTime(aadharDetails?.createdAt)} />
                            <DetailRow label="Updated At" value={formatDateTime(aadharDetails?.updatedAt)} />
                            <tr>
                              <th style={{ width: "32%", backgroundColor: "#f7f7f7" }}>Aadhaar PDF</th>
                              <td>
                                {aadhaarPdfUrl ? (
                                  <a href={aadhaarPdfUrl} target="_blank" rel="noreferrer">
                                    View PDF
                                  </a>
                                ) : (
                                  "-"
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="panel panel-default">
                      <div className="panel-heading" style={{ padding: "10px 15px", fontWeight: 600 }}>
                        Address Details
                      </div>
                      <div className="panel-body" style={{ padding: 0 }}>
                        <table className="table table-bordered table-striped mb-0">
                          <tbody>
                            <DetailRow label="Country" value={aadharDetails?.address?.country} />
                            <DetailRow label="State" value={aadharDetails?.address?.state} />
                            <DetailRow label="District" value={aadharDetails?.address?.dist} />
                            <DetailRow label="Sub District" value={aadharDetails?.address?.subdist} />
                            <DetailRow label="PO" value={aadharDetails?.address?.po} />
                            <DetailRow label="Village/Town" value={aadharDetails?.address?.vtc} />
                            <DetailRow label="Locality" value={aadharDetails?.address?.loc} />
                            <DetailRow label="Street" value={aadharDetails?.address?.street} />
                            <DetailRow label="House" value={aadharDetails?.address?.house} />
                            <DetailRow label="Landmark" value={aadharDetails?.address?.landmark} />
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
